const PROBLEM_IMG =
  "https://customer-assets.emergentagent.com/job_page-generator-46/artifacts/3clzupuv_Xteriorworks3.png";

const FACTS = [
  {
    n: "361×",
    t:
      "Shopping cart handles contain 361× more bacteria than the average public toilet seat, based on food-safety surface testing studies.",
  },
  {
    n: "72%",
    t:
      "72% of shopping carts tested positive for fecal bacteria in a University of Arizona study — the highest contamination rate of any public surface tested.",
  },
  {
    n: "15s",
    t:
      "Our ATP bioluminescence testing delivers a surface bacteria score in 15 seconds — before and after every service visit, documented and on file.",
  },
  {
    n: "$60K+",
    t:
      "The average replacement value of a 200-cart fleet. Proactive maintenance meaningfully extends service life and protects that investment.",
  },
];

export default function Problem() {
  return (
    <section
      id="why"
      data-testid="problem-section"
      className="py-16 md:py-32 bg-[var(--xw-bg)] border-b border-[var(--xw-line)]"
    >
      <div className="xw-container">
        {/* section header */}
        <div className="grid grid-cols-12 gap-8 items-end">
          <div className="col-span-12 lg:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="font-mono-xw text-[11px] tracking-[0.22em] uppercase text-[var(--xw-orange)]">
                § 01 — The Problem
              </span>
              <span className="h-px w-16 bg-[var(--xw-line)]" />
            </div>
            <h2
              data-testid="problem-headline"
              className="font-display font-black uppercase tracking-[-0.03em] leading-[0.9]"
              style={{ fontSize: "clamp(2rem, 7vw, 5rem)" }}
            >
              Your Carts Are A<br />
              <span className="italic font-medium" style={{ color: "var(--xw-orange)" }}>
                Public Health Concern.
              </span>
            </h2>
          </div>
          <div className="col-span-12 lg:col-span-5 xw-reveal">
            <p className="text-[16px] md:text-[17px] leading-relaxed text-[var(--xw-ink-soft)]">
              Most businesses invest heavily in what's inside their four walls —
              and let the exterior manage itself. The data shows why that's a
              problem.
            </p>
          </div>
        </div>

        {/* split layout */}
        <div className="mt-10 md:mt-16 grid grid-cols-12 gap-6 md:gap-8">
          {/* Image column */}
          <div className="col-span-12 lg:col-span-6">
            <div className="relative overflow-hidden h-[340px] sm:h-[460px] md:h-[620px] xw-reveal">
              <img
                src={PROBLEM_IMG}
                alt="Xterior Works technician disinfecting a shopping cart handle with a branded spray bottle"
                className="w-full h-full object-cover select-none"
                draggable="false"
              />
              <div className="absolute top-3 left-3 bg-[var(--xw-ink)] text-white px-2.5 py-1 font-mono-xw text-[10px] tracking-[0.18em]">
                ATP / SAMPLE 0142
              </div>
              <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between bg-white/90 backdrop-blur px-3 py-2 border border-[var(--xw-line)] gap-2">
                <span className="font-mono-xw text-[9px] md:text-[11px] tracking-[0.16em] md:tracking-[0.2em] uppercase">
                  Pre RLU
                </span>
                <span className="font-display font-bold text-base md:text-lg text-[var(--xw-orange)]">
                  2,431
                </span>
                <span className="font-mono-xw text-[9px] md:text-[11px] tracking-[0.16em] md:tracking-[0.2em] uppercase">
                  Post: 18
                </span>
              </div>
            </div>
          </div>

          {/* Copy + facts column */}
          <div className="col-span-12 lg:col-span-6">
            <div className="space-y-5 text-[15px] md:text-[16px] leading-relaxed text-[var(--xw-ink-soft)] xw-reveal">
              <p>
                Shopping carts are among the{" "}
                <strong className="font-semibold">
                  highest-touch surfaces in any commercial environment.
                </strong>{" "}
                Hundreds of hands grip the same handles every single day.
                Children sit in basket seats. Raw groceries, personal items,
                and hand contact accumulate across every cart in your fleet —
                with most going weeks or months between proper sanitation.
              </p>
              <p>
                Beyond the public health dimension, there is a direct{" "}
                <strong className="font-semibold">
                  financial and liability argument
                </strong>{" "}
                for proactive cart management. A single cart costs $150–$300 to
                replace. A fleet of 200 represents a $30,000–$60,000 asset
                sitting outside, exposed to weather, traffic, and daily wear —
                with most organizations tracking none of it.
              </p>
            </div>

            {/* facts grid */}
            <div className="mt-8 md:mt-10 grid grid-cols-1 sm:grid-cols-2 border-t border-l border-[var(--xw-line)]">
              {FACTS.map((f, i) => (
                <div
                  key={f.n}
                  data-testid={`problem-fact-${i}`}
                  className="p-5 sm:p-6 md:p-7 border-r border-b border-[var(--xw-line)] bg-white"
                >
                  <div
                    className="xw-num text-[44px] sm:text-5xl md:text-6xl"
                    style={{ color: "var(--xw-orange)" }}
                  >
                    {f.n}
                  </div>
                  <p className="mt-3 text-[13.5px] leading-snug text-[var(--xw-ink-soft)]">
                    {f.t}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
